import React, { useState } from 'react';
import { router, usePage } from '@inertiajs/react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import CreditsInfo from '../../Components/CreditsInfo';
import './EditPoster.css'; // Ensure you have your CSS imported

const EditPoster = () => {
    const { movie_title, movie_hash, user_email, poster, prompt: initialPrompt, credits, posterUrl, reload, error, success, edition } = usePage().props;
    const [prompt, setPrompt] = useState(initialPrompt || '');
    const [posterFile, setPosterFile] = useState(null);
    const [guidance, setGuidance] = useState(''); // New state for guidance text
    const [isLoading, setIsLoading] = useState(false);

    // Poster options that WORK, live-probed 2026-10-07. Credits by cost band.
    // MUST stay in sync with MovieController::regeneratePoster.
    const POSTER_OPTIONS = [
        { value: 'nano_banana_2',         label: 'Google Nano Banana 2.1 — 1K',             cost: 2 },
        { value: 'nano_banana_2_2k',      label: 'Google Nano Banana 2.1 — 2K, sharpest',    cost: 3 },
        { value: 'gpt_image_25_flare',    label: 'OpenAI GPT Image 2.5 Flare — fast',        cost: 1 },
        { value: 'gpt_image_25_sunburst', label: 'OpenAI GPT Image 2.5 Sunburst — high quality', cost: 2 },
        { value: 'leonardo',              label: 'Leonardo — photoreal art, no title text',  cost: 1 },
    ];
    const [provider, setProvider] = useState(edition === 'deluxe' ? 'nano_banana_2_2k' : 'nano_banana_2');
    const posterCost = (POSTER_OPTIONS.find((o) => o.value === provider) || POSTER_OPTIONS[0]).cost;

    const regeneratePoster = (e) => {
        e.preventDefault();
        setIsLoading(true);
        router.post(`/movies/${movie_hash}/regenerate-poster`, {
            prompt,
            provider
        }, {
            onFinish: () => {
                setIsLoading(false);
            }
        });
    };

    const uploadPoster = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('poster', posterFile);

        router.post(`/movies/${movie_hash}/upload-poster`, formData, {
            forceFormData: true,
            onSuccess: () => {
                setPosterFile(null);
                router.visit(window.location.href); // Reload the page to fetch the updated data
            }
        });
    };

    const generatePosterPrompt = (e) => {
        e.preventDefault();
        setIsLoading(true);
        router.post(`/movies/${movie_hash}/generate-poster-prompt`, {
            guidance
        }, {
            onFinish: () => {
                setIsLoading(false);
            },
            onSuccess: (response) => {
                setPrompt(response.props.prompt);
            }
        });
    };

    return (
        <div className="container position-relative">
            {isLoading && (
                <div className="overlay">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Generating...</span>
                    </div>
                    <div>Generation is in progress...</div>
                </div>
            )}

            <CreditsInfo
                movie_title={movie_title}
                movie_hash={movie_hash}
                initialCredits={credits}
                user_email={user_email}
            />

            <h1>Edit Poster for {movie_title}</h1>

            {error && (
                <div className="alert alert-danger">
                    {error}
                </div>
            )}

            {success && (
                <div className="alert alert-success">
                    {success}
                </div>
            )}

            {poster && posterUrl && (
                <div className="mb-3">
                    <img src={posterUrl} alt="Movie Poster" className="img-fluid" />
                </div>
            )}

            {!posterUrl && (
                <div className="alert alert-danger">
                    No Poster Image
                </div>
            )}

            <div className="form-group mb-3">
                <label htmlFor="guidance">Guidance for Prompt:</label>
                <textarea
                    id="guidance"
                    className="form-control"
                    rows="2"
                    value={guidance}
                    onChange={(e) => setGuidance(e.target.value)}
                    placeholder="Enter guidance for generating the prompt, such as what to focus on (optional)"
                />
            </div>

            <button className="mb-4 btn btn-secondary btn-block" onClick={generatePosterPrompt} disabled={isLoading}>Generate Prompt (1 credit)</button>

            <form onSubmit={regeneratePoster} className="mb-3">
                <div className="form-group">
                    <label htmlFor="prompt">Prompt:</label>
                    <textarea
                        name="prompt"
                        className="form-control"
                        rows="4"
                        value={prompt}
                        onChange={(e) => setPrompt(e.target.value)}
                        placeholder="Enter image prompt here"
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="provider">Image model:</label>
                    <select
                        id="provider"
                        className="form-control"
                        value={provider}
                        onChange={(e) => setProvider(e.target.value)}
                        required
                    >
                        {POSTER_OPTIONS.map((o) => (
                            <option key={o.value} value={o.value}>
                                {o.label} ({o.cost} credit{o.cost === 1 ? '' : 's'})
                            </option>
                        ))}
                    </select>
                </div>

                <button type="submit" className="btn btn-primary btn-block" disabled={isLoading}>
                    Regenerate Poster ({posterCost} credit{posterCost === 1 ? '' : 's'})
                </button>
            </form>

            <form onSubmit={uploadPoster} className="mb-3">
                <div className="form-group">
                    <label htmlFor="poster">Upload Poster:</label>
                    <input
                        type="file"
                        id="poster"
                        className="form-control-file"
                        onChange={(e) => setPosterFile(e.target.files[0])}
                        required
                    />
                </div>
                <button type="submit" className="btn btn-success btn-block">Upload Poster</button>
            </form>
        </div>
    );
};

export default EditPoster;
